import { Helmet } from "react-helmet-async";
import { business } from "../config/business";

// Sitewide Organization/LocalBusiness schema, rendered once via Layout so it
// appears on every page — the base entity that Service/Article/BreadcrumbList
// schema on individual pages references back to. Only verified, real facts
// (address, phone, email) — no fabricated ratings, review counts or awards.
const OrganizationSchema = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${business.siteUrl}/#organization`,
    name: business.name,
    url: business.siteUrl,
    telephone: business.phone.display,
    email: business.email.display,
    address: {
      "@type": "PostalAddress",
      streetAddress: business.address.line,
      addressRegion: "Telangana",
      addressCountry: "IN",
    },
    areaServed: [
      { "@type": "State", name: "Telangana" },
      { "@type": "State", name: "Andhra Pradesh" },
    ],
    sameAs: [business.social.facebook, business.social.instagram, business.social.linkedin],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;
